import React from 'react'
import Popup from '@Components/Popups/Popup'
import ConfirmationPopup from '@Components/Popups/ConfirmationPopup'

export interface IsNonRepresentativePopupProps {
    onClose: () => void
}
const IsNonRepresentativePopup = ({ onClose }: IsNonRepresentativePopupProps) => (
    <div className="non-representative-popup">
        <Popup onClose={onClose}>
            <ConfirmationPopup
                title="You should only be registering works and claiming shares for entities that you administer."
                onConfirm={onClose}
                confirmButtonText="Done"
            >
                <p>
                    <b>Are you working with a publishing rights administrator?</b> <br />
                    If you currently work with an administrator, and that administrator registers your musical works and
                    collects digital audio mechanicals on your behalf, then you are probably NOT a self-administered
                    songwriter. Your administrator will work with The MLC on your behalf. If you have further questions,
                    we encourage you to contact your rights administrator.
                    <br />
                    <br /> Still not sure? <b>Click the Chat bubble at the bottom of your screen </b>
                    to connect with our Support Teams for more help.
                </p>
            </ConfirmationPopup>
        </Popup>
    </div>
)

export default IsNonRepresentativePopup
